import { useState } from 'react';
import { NoteCard } from '@/reports/index';
import { LizanoReportResponse as AccountNotes } from '@/reports/sections/ListsSection/lists/lists';
import { ReportNote } from '@/reports/sections/NotesSection/Notes/Notes';
import { Link } from '@/theme/index';
import { ListContainer } from './components';

export function AccountNotesList({ report }: { report: AccountNotes }) {
  const [showMoreOpen, setShowMoreOpen] = useState(false);

  if (!showMoreOpen && report?.notes && report?.notes?.length > 1) {
    return (
      <ListContainer>
        {report?.notes?.slice(0, 1).map((note: ReportNote) => (
          <NoteCard key={`note-closed-${note.id}`} note={note} />
        ))}
        <Link
          variant="button"
          sx={{ textAlign: 'center' }}
          onClick={() => setShowMoreOpen(true)}
          color="success.main"
          underline="always"
        >
          Show More
        </Link>
      </ListContainer>
    );
  }

  return (
    <div>
      {report?.notes?.map((note: ReportNote) => (
        <NoteCard note={note} key={`note-open-${note.id}`} />
      ))}
    </div>
  );
}
